import { Home, UsersRound } from 'lucide-react';

import type { NavigationConfigItem } from '@/shared/config/navigation.types';

// Medical Web v3 GNB top tabs (no LNB). Per PRD/IA, only 2 top-level tabs.
export const medicalTopTabs: readonly NavigationConfigItem[] = [
  { labelKey: 'navigation.home', path: '/home', icon: Home },
  { labelKey: 'navigation.patientManagement', path: '/patients', icon: UsersRound },
];
